import { createContext } from 'react';

export const DrawerContext = createContext({
  open: true,
  toggleDrawer: () => {},
});
